(() => {
  const ELEMENT_NAME = "collection-discount-progress";
  const CART_EVENTS = ["cart:updated", "cart:refresh", "cart:change", "cart:update"];
  const getCount = (payload) => {
    const candidates = [payload?.item_count, payload?.cartData?.item_count, payload?.cart?.item_count, payload?.detail?.item_count, payload?.detail?.cartData?.item_count, payload?.detail?.cart?.item_count];
    const count = candidates.find((value) => Number.isFinite(Number(value)));
    return count === undefined ? null : Math.max(0, Number(count));
  };
  const updateAll = (count) => {
    if (count === null) return;
    document.querySelectorAll(ELEMENT_NAME).forEach((element) => element.update(count));
  };
  if (!customElements.get(ELEMENT_NAME)) {
    customElements.define(ELEMENT_NAME, class CollectionDiscountProgress extends HTMLElement {
      connectedCallback() { this.update(Number(this.dataset.itemCount || 0)); }
      update(rawCount) {
        const count = Math.max(0, Number(rawCount) || 0);
        this.dataset.itemCount = String(count);
        const title = "🔥 Build Your Collection";
        let detail;
        let progress;
        if (count < 2) {
          const remaining = 2 - count;
          detail = `Add ${remaining} more ${remaining === 1 ? "item" : "items"} to unlock 10% OFF`;
          progress = (count / 2) * 16;
        } else if (count < 4) {
          detail = "10% OFF unlocked";
          progress = 16 + ((count - 2) / 2) * 34;
        } else if (count < 8) {
          detail = "15% OFF unlocked";
          progress = 50 + ((count - 4) / 4) * 34;
        } else {
          detail = "20% OFF unlocked";
          progress = 84;
        }
        this.querySelector("[data-collection-discount-title]").textContent = title;
        this.querySelector("[data-collection-discount-detail]").textContent = detail;
        this.style.setProperty("--collection-discount-progress", `${progress}%`);
        this.querySelectorAll("[data-threshold]").forEach((element) => element.classList.toggle("is-active", count >= Number(element.dataset.threshold)));
      }
    });
  }
  CART_EVENTS.forEach((eventName) => document.addEventListener(eventName, (event) => updateAll(getCount(event))));
  if (window.webvista?.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.webvista.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (payload) => updateAll(getCount(payload)));
  }
})();
